<template>
  <div>
      <div class="col-md-12 m-0 p-0">
        <div class="col-12 col-md-12 m-auto m-0 p-0">
          <div class="col-12 m-0 p-0">
            <div class="col-md-12 d-flex justify-content-end my-2">
              <b-button variant="light" class="border" @click="generatePaymentTicketToggler =! generatePaymentTicketToggler" size="sm">Create Ticket</b-button>
            </div>
            <div class="payment-retrieval-history col-12 m-0 p-2 text-left">
              <p><strong>Payment retrieval history (#{{bookingId}})</strong></p>
              <div v-if="loading">
                <p>
                  <b-spinner small class="mr-2 pt-0"></b-spinner>Loading....
                </p>
              </div>
              <div v-else>
                <div class="card p-2 my-2" v-for="(data, index) in paymentRetrievalHistory" :key="index">
                  <p>#{{data.bookingId}}</p>
                  <p class="m-0 p-0" v-if="data.status === 1"><b-badge variant="success">Paid</b-badge></p>
                  <p class="m-0 p-0" v-if="data.status === 0"><b-badge variant="danger">Due</b-badge></p>
                  <p class="m-0 p-0"><strong>{{data.amount | currency}}</strong></p>
                  <p class="m-0 p-0">{{data.comment}}</p>
                  <div>
                    <p class="label m-0 p-0">{{data.agentData.userName}} on {{data.createdAt | moment('MMMM Do YYYY')}}</p>
                  </div>
                  <div class="col-12 text-right">
                    <p class="m-0 p-0">Due: {{data.balance | currency}}</p>
                  </div>
                </div>
                <div class="card py-5 px-2 text-center my-2" v-if="paymentRetrievalHistory.length === 0">
                  <p class="label">There are no records.</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <b-modal scrollable hide-footer title="Create Payment Ticket" centered v-model="generatePaymentTicketToggler">
        
        <div class="row col-md-12 col-12 m-0 p-0" >
          <div class="mb-3 col-md-6 m-0 p-2">
            <p class="labels m-0 p-0">Amount</p>
            <input type="number" class="form-control" v-model="obj.amount" />
          </div>
          <div class="mb-3 col-md-12 m-0 p-2">
            <p class="labels m-0 p-0">Address</p>
            <textarea type="text" class="form-control" v-model="obj.address" />
          </div>
          <div class="mb-3 col-md-12 m-0 p-2">
            <p class="labels m-0 p-0">Comment</p>
            <textarea type="text" class="form-control" v-model="obj.comment" />
          </div>
          <div class="col-12 m-0 p-2">
            <div>
              <b-form-checkbox v-model="obj.allowPartial" name="check-button" switch>
                Allow Partial Payment
              </b-form-checkbox>
            </div>
          </div>
          <div class="text-right col-12 m-0 p-0">
            <b-button @click="createTicket" :disabled="invalid" variant="light" class="border">Create Ticket</b-button>
          </div>
        </div>
      </b-modal>
  </div>
</template>

<script>
export default {
  data () {
    return {
      generatePaymentTicketToggler: false,
      obj: {
        bookingId: '',
        amount: 0,
        allowPartial: false,
        address: null,
        comment: null
      }
    }
  }, 
  props : { 
    bookingId: {
        type: [Number, String],
        required: false,
        // default: 633
        default: null
    }
  },
  created () {
    this.fetchData()
    this.obj.bookingId = this.bookingId
  },
  watch : {
    bookingId (value) {
      this.obj.bookingId = value
    }
  },
  methods: {
    fetchData() {
      this.$store.dispatch("getPaymentTickets", { params: {
          booking: this.bookingId
        } })
    },
    createTicket() {
      console.log(this.obj)
      this.$store.dispatch("createPaymentTickets", this.obj).then (()=> {
        this.generatePaymentTicketToggler = false
        this.fetchData()
      }).catch(()=> {alert('error')})
    }
  },
  computed : {
    loading () {
      return this.$store.state.loading_api
    },
    paymentRetrievalHistory () {
      return this.$store.state.paymentRetrievalHistory
    },
    invalid () {
      if (this.obj.bookingId && this.obj.address && this.obj.comment && this.amount > 0) {
        return true
      } else{
        return false
      }
    }
  }
}
</script>

<style scoped>
.label{
  font-size: 12px;
  color: gray;
}
</style>